<template>
  <div>
    <template v-if="type === 'success'">
      <div v-if="qrCode" class="qr_code_box success">
        <p class="tip_">可长按识别二维码添加小助手咨询预约进度</p>
        <img class="qr_code" :src="qrCode" alt="二维码" />
      </div>
      <div v-else class="qr_code_box success">
        <p class="tip_">
          可发送邮件至<span class="email">kefu@ssish.com</span>咨询预约进度
        </p>
      </div>
    </template>
    <template v-else>
      <div v-if="qrCode" class="qr_code_box">
        <img class="qr_code" :src="qrCode" alt="二维码" />
        <p class="tip_">长按识别二维码可添加小助手咨询产品</p>
      </div>
      <div v-else class="qr_code_box">
        <p class="tip_">
          可发送邮件至<span class="email">kefu@ssish.com</span>咨询产品
        </p>
      </div>
    </template>
  </div>
</template>
<script>
import api from "@/utils/nsaleApi";
export default {
  props: {
    userId: {
      type: String,
    },
    isFengChannel: {
      type: Boolean,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      qrCode: "",
    };
  },
  created() {
    if (!this.isFengChannel) {
      this.qrCode = require("../../../assets/image/yf/dieqrcode.png");
      return;
    }
    this.queryUserQrCode();
  },
  methods: {
    // 获取推荐人员二维码
    queryUserQrCode() {
      if (!this.userId) {
        this.qrCode = require("../../../assets/image/yf/qrcode_feng.png");
        return;
      }
      // 安联安享至尊养老年金保险（分红型）默认此二维码
      if (this.$route.query.productCode === "ALAXZZYLNJ2024") {
        this.qrCode = require("../../../assets/image/yf/qrcode_zl.png");
        return;
      }
      api
        .queryQrCodeByCuswebuserid(this.userId)
        .then((res) => {
          if (res.data.returnCode === "0000" && res.data.content) {
            this.qrCode = res.data.content;
          } else {
            this.qrCode = require("../../../assets/image/yf/qrcode_feng.png");
          }
        })
        .catch(() => {
          this.qrCode = require("../../../assets/image/yf/qrcode_feng.png");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.qr_code_box {
  margin-bottom: 25px;
  .qr_code {
    width: 154px;
    height: 154px;
  }
}
.tip_ {
  text-align: center;
  margin-top: 16px;
  font-size: 18px;
  color: #222;
  font-weight: 500;
  .email {
    user-select: text;
    color: #6495ed;
  }
}

.success {
  .tip_ {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #303030;
    line-height: 23px;
    margin: 19px 0;
  }
  .qr_code {
    width: 154px;
    height: 154px;
  }
}
</style>
